import React, { useMemo } from 'react'
import { useGetEventUserQuery, useUpdateEventUserMutation } from '../../api/eventUser.api'
import FormBuilder from '../../components/FormBuilder'
import HTML from '../../components/HTML'
import { useMyContext } from '../../context/context'
import useConf from '../../hooks/useConf'
import useSettingsV2 from '../../hooks/useSettingsV2'
import { useSteps } from './Steps'

const Informations = () => {
  const { myContext, userId: myUserId, user } = useMyContext()
  const { settings } = useSettingsV2()
  const { nextStep, userId, setUserId, NextButton, participation } = useSteps()
  const { formV2Id } = useConf(participation)

  const [updateEventUser] = useUpdateEventUserMutation()
  const { data: meData } = useGetEventUserQuery(myContext)

  const html = useMemo(() => {
    if (participation === 5) {
      return settings?.FO_MEETING_COMPANIONS_TOP_HTML || settings?.FO_MEETING_INFO_HTML
    }
    if (participation === 2) {
      return settings?.FO_MEETING_SHOW_REPRESENTED_BY_HTML || settings?.FO_MEETING_INFO_HTML
    }
    return settings?.FO_MEETING_INFO_HTML
  }, [participation, settings])

  const force = useMemo(() => participation === 5, [participation])

  return (
    <div>
      <HTML value={html} />
      <FormBuilder
        key={`informations-${userId || 'new'}`}
        force={force}
        formIdDefault={formV2Id}
        userId={userId || 0}
        onFinish={async u => {
          if (myUserId !== u?.id) {
            const isCompanion = participation === 5
            await updateEventUser({
              ...myContext,
              userId: u.id,
              eventUser: {
                registeredBy: participation !== 2 ? `${user.firstName || ''} ${user.lastName || ''} (${user.id})` : null,
                ...(isCompanion ? { registeredBy2: user.id } : {}),
                ...(isCompanion && settings?.FO_MEETING_COMPANIONS_COPY_EXTENDED ? { extended: meData?.UserEvent?.extended || {} } : {}),
                isRemote: false,
                registeredFrom: localStorage.getItem('canal') || 'WEB',
                typo: meData?.UserEvent?.typo,
                typoId: meData?.UserEvent?.typoId,
              },
            })
          }
          setUserId(u.id)
          nextStep()
        }}
        Buttons={NextButton}
      />
    </div>
  )
}

export default Informations
